import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Icon, Flex, Text, colors,
} from 'react-orange-ui';

import { removeLastImageCaptcha } from '../../actions/captcha_actions';
import WordingService from '../../services/WordingService';

const Wrapper = styled(Flex)`
  width: 4rem;
  margin-left: 0.5rem;
`;

const PreviewImage = styled.img`
  height: 38px;
  width: 38px;
`;

const RemovableItem = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  &:focus {
    outline: ${colors.black} dotted 2px;
  }
`;

const Thumbnail = (props) => {
  const {
    status,
    image,
  } = props;

  let thumbnail = '';
  switch (status) {
    case 'LAST':
      thumbnail = (
        <RemovableItem onClick={props.removeLastImageCaptcha} className="remove-indication">
          <PreviewImage value={image.value} src={image.data} alt="removable-previous" />
          <Icon icon="delete" height={18} width={18} />
        </RemovableItem>
      );
      break;
    case 'PREVIOUS':
      thumbnail = <PreviewImage value={image.value} src={image.data} alt="previous" className="indication-thumbnail" />;
      break;
    case 'CURRENT':
      thumbnail = (
        <Text color="orange" bold size="l" className="waiting">
          {WordingService.getWording('caption', 'captchaSymbolWaiting')}
        </Text>
      );
      break;
    default:
      break;
  }
  return (
    <Wrapper alignItems="center">
      {thumbnail}
    </Wrapper>
  );
};

Thumbnail.defaultProps = {
  image: null,
};

Thumbnail.propTypes = {
  /** Action to remove last selected image */
  removeLastImageCaptcha: PropTypes.func.isRequired,
  /** User input captcha status */
  image: PropTypes.shape({
    format: PropTypes.string,
    value: PropTypes.number,
    data: PropTypes.string,
  }),
  /** Indication status */
  status: PropTypes.oneOf(['PREVIOUS', 'LAST', 'CURRENT', 'NEXT']).isRequired,
};

const mapDispatchToProps = dispatch => ({
  removeLastImageCaptcha: () => dispatch(removeLastImageCaptcha()),
});

export default connect(
  null,
  mapDispatchToProps,
)(Thumbnail);
